module.exports = __webpack_public_path__ + "static/img/A71.dfa78bc3.jpg";